import styled, { css } from "styled-components";

const commonStyles = css`
  display: contents;
  .containerIntermediadores {
    width: 100rem;
    max-width: 90vw;
    > .togglesContainer {
      padding: 2rem 0;
      display: flex;
      justify-content: center;
      flex-direction: column;
      align-items: center;
      gap: 3rem;
      .dropdown {
        .configsCartaoContainer {
          position: relative;
          display: flex;
          flex-direction: column;
          width: 40rem;
          align-items: center;
          gap: 3rem;

          &::after {
            content: "";
            position: absolute;
            width: 35rem;
            height: 2px;
            border-radius: 50px;
            background-color: ${(props) => props.theme.colors.elements};
            bottom: 0;
          }
        }

        .jurosParcelasSection {
          width: 40rem;
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          gap: 1rem;
          padding-bottom: 3rem;

          .jurosParcelasGrid {
            display: grid;
            grid-template-columns: repeat(4, 1fr);
            gap: 1rem;
            width: 100%;

            .jurosInputWrapper {
              position: relative;

              .jurosPrefix {
                position: absolute;
                left: 3px;
                bottom: 3px;
                height: 30px;
                display: flex;
                align-items: center;
                justify-content: center;
                pointer-events: none;
                z-index: 2;
                color: #636466;
                font-size: 10px;
                width: 30px;
                background-color: #f6f6f6;
                border-radius: 50%;

                @media(max-width: 1280px){
                  height: 25px;
                  width: 25px;
                }
              }

              .jurosInput {
                padding-left: 6.8rem !important;
              }
            }

            @media (max-width: 768px) {
              grid-template-columns: repeat(2, 1fr);
            }
          }
        }

        .configsPixContainer {
          width: 40rem;
          display: flex;
          flex-direction: column;
          gap: 2rem;

          .cancelamentoContainer {
            display: flex;
            flex-direction: column;
            gap: 1.5rem;

            .cancelamentoToggle {
              display: flex;
              align-items: center;
              gap: 1rem;
            }

            .cancelamentoInfo {
              font-size: 10px;
              color: #888;
              text-align: left;
            }
          }
        }
      }
    }
  }
`;

export const ContainerIntermediadorContainer = styled.div<{
  configIn: "configuracoes" | "empresa" | "catalogo";
}>`
  ${commonStyles}
  ${({ configIn }) =>
    configIn === "empresa" &&
    css`
      .containerIntermediadores {
        .togglesContainer {
          gap: 1rem;
          .dropdown {
            display: flex;
            flex-direction: column;
            align-items: center;
          }
        }
      }
    `};
  ${({ configIn }) =>
    configIn === "catalogo" &&
    css`
      .containerIntermediadores {
        width: 100%;
        max-width: 100%;
        .togglesContainer {
          gap: 0rem;
          width: 100%;
          .containerToggleConfigurar {
            width: 100%;
            .nome {
              color: ${(props) => props.theme.colors.tertiary};
              width: 100%;
            }
          }
          .dropdown {
            width: 100%;
            .configsCartaoContainer {
              padding: 0 0 11px 0;
              width: 100%;
              gap: 1rem;
              display: grid;
              grid-template-columns: repeat(auto-fit, minmax(40rem, 1fr));
              &::after {
                display: none;
              }
            }
            .jurosParcelasSection {
              width: 100%;
            }
            .configsPixContainer {
              width: 100%;
            }
          }
        }
      }
    `}
  ${({ configIn }) =>
    configIn === "configuracoes" &&
    css`
      .containerIntermediadores {
        width: 100%;
        max-width: 100%;
        padding: 0 2rem;
        .togglesContainer {
          gap: 0rem;
          .containerToggleConfigurar {
            width: 100%;
            .nome {
              color: ${(props) => props.theme.colors.tertiary};
              font-weight: bold;
              width: 100%;
            }
          }
          .dropdown {
            width: 100%;
            .configsCartaoContainer {
              padding: 0 0 3rem 0;
              width: 100%;
              gap: 1rem;
              display: grid;
              grid-template-columns: repeat(auto-fit, minmax(40rem, 1fr));
              &::after {
                display: none;
              }
            }
            .jurosParcelasSection {
              width: 100%;
            }
            .configsPixContainer {
              width: 100%;
            }
          }
        }
      }
    `}
`;

// Add other styled components for the nested elements if necessary
